<template>
  <div class="transaction-detail">
    <b-row>
      <b-col cols="12" md="9">
        <p class="m-0 text-header bold">
          รายละเอียดการจอง : {{ data?.invoiceNo }}
        </p>
      </b-col>
      <b-col cols="12" md="3">
        <div class="header right" v-if="data">
          <div
            class="status"
            :style="`background-color:${data.calendarPrimaryColor}`"
          >
            <p class="m-0">
              {{ data.statusName }}
            </p>
          </div>
        </div>
      </b-col>
    </b-row>

    <div class="detail">
      <div class="detail-header">
        <p class="m-0 bold text-white">ข้อมูลการจอง</p>
        <!-- <p class="m-0 bold">Date time transaction :</p> -->
      </div>
      <div class="detail-body" v-if="data">
        <b-row>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">ชื่อ - นามสกุล</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.fullName }}
              </p>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">บริการ</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.eventGroupName }}
              </p>
            </div>
          </b-col>

          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">อีเมล</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.email || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">รอบ วันที่ + เวลา</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{
                  $moment(data.bookingDate).locale("th").format("Do MMMM YYYY")
                }}
                {{ data.startTimeShow }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">เบอร์โทรศัพท์</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.telephone || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">แบรนด์</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.brandName }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">ราคาสุทธิ</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ formatNumber(data.grandTotal) }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">หมายเลขการจอง</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.invoiceNo || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">Id.</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.transactionShowId }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">หมายเหตุเพิ่มเติม</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.note || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">ยืนยันโดย</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.confirmBy || "-" }}
              </p>
            </div>
          </b-col>

          <b-col cols="12" md="6" v-if="data.customerFlowStatusId === 2">
            <div class="list-detail">
              <p class="m-0 bold mw-100">หมายเหตุเพิ่มเติมกรณียกเลิก</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.canceledNote || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6" v-if="data.customerFlowStatusId === 2">
          </b-col>

          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">สาขา</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.venueName || "-" }}
              </p>
            </div>
          </b-col>

          <b-col cols="12" md="6" v-if="$isEventGroup !== true">
            <div class="list-detail">
              <p class="m-0 bold mw-100">คูปอง</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.promocodeSerialNo || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6" v-if="$isEventGroup !== true">
            <div class="list-detail">
              <p class="m-0 bold mw-100">คูปอง</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 bold w-full">
                {{ data.promoCodeName || "-" }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="detail">
      <div class="detail-header">
        <p class="m-0 bold text-white">ข้อมูลการชำระเงิน</p>
        <b-button
          class="btn-filter"
          @click="getPaymentInfo"
          v-if="data && data.paymentTypeId === 1"
        >
          Payment
        </b-button>
      </div>
      <div class="detail-body" v-if="data">
        <b-row>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">รูปแบบการชำระเงิน</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.paymentTypeName }}
              </p>
            </div>

            <div class="list-detail">
              <p class="m-0 bold mw-100">รหัสอ้างอิงการชำระเงิน</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.paymentTransactionId || "-" }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">เวลาที่ชำระเงิน</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.paymentTime || "-" }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="detail" v-if="data && data.displayCanceledNote">
      <div class="detail-header">
        <p class="m-0 bold text-white">ข้อมูลการยกเลิก</p>
      </div>
      <div class="detail-body">
        <b-row>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">เหตุผลในการยกเลิก</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.canceledNote || "-" }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="detail" v-if="data && data.hasBilling == 1">
      <div class="detail-header">
        <p class="m-0 bold">Billing</p>
        <!-- <b-button class="btn-filter">click me</b-button> -->
      </div>
      <div class="detail-body">
        <b-row>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">Tax Id</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.taxId }}
              </p>
            </div>

            <div class="list-detail">
              <p class="m-0 bold mw-100">Address</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.address }}
              </p>
            </div>

            <div class="list-detail">
              <p class="m-0 bold mw-100">District</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.districtName }}
              </p>
            </div>

            <div class="list-detail">
              <p class="m-0 bold mw-100">Zipcode</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.zipCode }}
              </p>
            </div>
          </b-col>
          <b-col cols="12" md="6">
            <div class="list-detail">
              <p class="m-0 bold mw-100">Name</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.name }}
              </p>
            </div>

            <div class="list-detail">
              <p class="m-0 bold mw-100">Sub District</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.subdistrictName }}
              </p>
            </div>

            <div class="list-detail">
              <p class="m-0 bold mw-100">Province</p>
              <p class="m-0 mr-2">:</p>
              <p class="m-0 w-full">
                {{ data.billingDetail.provinceName }}
              </p>
            </div>
          </b-col>
        </b-row>
      </div>
    </div>

    <div class="table" v-if="items.length > 0">
      <Table
        :items="items"
        :footerItem="footerItem"
        :fields="fields"
        :isBusy="isBusy"
        :rows="rows"
        :pageOptions="pageOptions"
      />
    </div>

    <ModalConfirmPayment
      :dataPayment="dataPayment"
      @confirmSuccess="confirmSuccess"
    />
    <ModalTextArea
      id="cancel"
      ref="cencelModal"
      text="ต้องการยกเลิกการจองใช่หรือไม่"
      @handler="handleCancel"
      showIcon
      label="เหตุผลในการยกเลิก"
      placeholder="กรุณาระบุเหตุผลในการยกเลิก"
    />

    <ModalUserConfirm ref="modalUserConfirm" @select="handleConfirm" />

    <div class="btn-display">
      <b-button
        variant="outline-primary"
        v-if="[4].includes(data?.customerFlowStatusId)"
        @click="onClickCancel"
        class="btn-cancel"
      >
        REJECT
      </b-button>
      <b-button
        variant="outline-primary"
        v-if="[3].includes(data?.customerFlowStatusId)"
        @click="handleNoShow"
      >
        NO SHOW
      </b-button>
      <b-button
        variant="primary"
        v-if="[3].includes(data?.customerFlowStatusId)"
        @click="handleComplete"
      >
        COMPLETE
      </b-button>
      <b-button
        variant="primary"
        v-if="[4].includes(data?.customerFlowStatusId)"
        @click="openConfirmPopup"
      >
        CONFIRM
      </b-button>
    </div>
  </div>
</template>

<script>
import Table from "./component/Table.vue";
import ModalConfirmPayment from "@/components/modal/ModalConfirmPayment.vue";
import ModalTextArea from "@/components/modal/ModalTextArea";
import ModalUserConfirm from "../component/ModalUserConfirm.vue";
export default {
  components: {
    Table,
    ModalConfirmPayment,
    ModalTextArea,
    ModalUserConfirm,
  },
  data() {
    return {
      data: null,
      dataPayment: null,

      // state table
      items: [],
      footerItem: {},

      fields: [
        {
          key: "productName",
          label: "ชื่อ",
        },
        {
          key: "quantity",
          label: "จำนวน",
        },
        {
          key: "subtotalPrice",
          label: "ราคาก่อนหักส่วนลด",
        },
        {
          key: "discountPrice",
          label: "ส่วนลด",
        },
        {
          key: "price",
          label: "ราคา",
        },
      ],
      isBusy: false,
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
    };
  },
  mounted() {
    this.getDetailTransaction();
    // this.getPaymentInfo();
  },
  methods: {
    async getDetailTransaction() {
      let payload = {};
      if (this.$isEventGroup !== undefined) {
        payload = {
          isEventGroup: this.$isEventGroup,
        };
      }

      const getData = await this.$services.transaction.getTransactionDetail(
        this.$route.params.id,
        payload
      );

      if (getData.result == 1) {
        this.data = getData.detail;
        this.items = getData.detail.productTable;
        this.footerItem = getData.detail.summaryProduct;
      }
    },
    async getPaymentInfo() {
      const getData = await this.$services.transaction.getPaymentInfo(
        this.$route.params.id
      );

      if (getData.result == 1) {
        // add state base64
        getData.detail.bankTransferList = getData.detail.bankTransferList.map(
          (x) => {
            // change format dateonly
            x.transactionDetail.dateOnly = x.transactionDetail.dateOnly
              .split("-")
              .reverse()
              .join("-");

            // add new key to obj
            let obj = {
              ...x,
              base64: {
                base64: null,
              },
              imageName: x.transactionDetail.slipImgUrl.split("/").reverse()[0],
            };
            // conver time

            x.transactionDetail.timeOnly = this.convertTime(
              x.transactionDetail.timeOnly
            );

            return obj;
          }
        );

        this.dataPayment = getData.detail;

        this.$bvModal.show("modal-confirm-payment");
      }
    },
    onClickCancel() {
      this.$refs.cencelModal.show();
    },
    async handleCancel(val, text) {
      if (val === true) {
        const respone = await this.$services.transaction.cancelTransaction(
          this.$route.params.id,
          text
        );
        this.getDetailTransaction();
      } else {
        this.$refs.cencelModal.close();
      }
    },
    convertTime(time) {
      let getTime = `${this.$moment().format("YYYY-MM-DDT")}${time}`;

      return getTime;
    },

    convertTimeHHMM(time) {
      return this.$moment(time).format("HH:mm");
    },

    confirmSuccess() {
      this.getDetailTransaction();
    },
    formatNumber(val) {
      return this.$services.utils.formatNumber(val);
    },
    async openConfirmPopup() {
      this.$refs.modalUserConfirm.show();
    },
    async handleConfirm(user) {
      const respone = await this.$services.transaction.confirmTransaction(
        this.$route.params.id,
        { userId: user.userId }
      );
      this.confirmSuccess();
    },
    async handleComplete() {
      const respone = await this.$services.transaction.completeTransaction(
        this.$route.params.id,
        this.data
      );
      this.confirmSuccess();
    },
    async handleNoShow() {
      const respone = await this.$services.transaction.noShowTransaction(
        this.$route.params.id,
        this.data
      );
      this.confirmSuccess();
    },
  },
};
</script>

<style lang="scss" scoped>
.transaction-detail {
  // font

  .text-header {
    font-size: 18px;
  }

  .bold {
    font-weight: bold;
  }

  .text-white {
    color: var(--font-color);
  }

  .header {
    &.right {
      display: flex;
      justify-content: flex-end;
    }

    .status {
      padding: 5px 15px;
      border-radius: 15px;
      color: white;
    }
  }

  .detail {
    .detail-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      background-color: var(--secondary-color);
      padding: 10px;
      margin-top: 10px;
    }

    .detail-body {
      background: white;
      padding: 10px;

      .list-detail {
        display: flex;
        margin-bottom: 5px;

        .mw-100 {
          min-width: 200px;
        }

        .w-full {
          width: 100%;
          text-align: right;
        }
      }
    }
  }

  .table {
    margin-top: 10px;
  }
  .btn-display {
    display: flex;
    justify-content: end;
    gap: 8px;
    .btn {
      width: 120px;
    }
    .btn-cancel {
      color: red;
      background-color: white;
      border-color: red;
    }
    .btn-cancel:hover {
      color: white;
      background-color: red;
      border-color: red;
    }
  }
}

// ! override
.btn-filter {
  min-width: 100px;
}
</style>
